import React, { PropTypes } from 'react'

const propTypes = {
  id: PropTypes.string,
  grey: PropTypes.bool
}

const CheckboxOff = props => (
  <svg
    width='24'
    height='24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <defs>
      <path id={`a-checkbox-off-${props.id}`} d='M0 0h175v40H0z' />
      <mask
        id={`b-checkbox-off-${props.id}`}
        x='0'
        y='0'
        width='175'
        height='40'
        fill='#fff'>
        <use xlinkHref={`#a-checkbox-off-${props.id}`} />
      </mask>
      <path
        d='M2 2.833v18.334c0 .46.373.833.833.833h18.334c.46 0 .833-.373.833-.833V2.833c0-.46-.373-.833-.833-.833H2.833C2.373 2 2 2.373 2 2.833zm18.333.834v16.666H3.667V3.667h16.666z'
        id={`c-checkbox-off-${props.id}`}
      />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path d='M0 0h24v24H0z' />
      <mask id={`d-checkbox-off-${props.id}`} fill='#fff'>
        <use xlinkHref={`#c-checkbox-off-${props.id}`} />
      </mask>
      <path
        d='M0 0h100v40H0z'
        mask={`url(#d-checkbox-off-${props.id})`}
        fill={props.grey ? '#dfdfdf' : '#000'}
      />
    </g>
  </svg>
)

CheckboxOff.propTypes = propTypes

export default CheckboxOff



// WEBPACK FOOTER //
// ./src/svg-icons/CheckboxOff.js